export default "__VITE_ASSET__CR7XlGGW__"